import {Injectable} from '@angular/core';
import {Requestor} from '@openid/appauth';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {XhrSettings} from 'ionic-appauth/lib/cordova';
import {AppPaths} from '../commons/app-paths';

@Injectable({
  providedIn: 'root'
})
export class NgHttpService implements Requestor {
  private lastTokenError: HttpErrorResponse | null = null;

  constructor(private http: HttpClient) {
  }

  public async xhr<T>(settings: XhrSettings): Promise<T> {
    if (!settings.method) {
      settings.method = 'GET';
    }

    try {
      return await this.performRequest<T>(settings) as T;
    } catch (error) {
      if (settings.url && settings.url.includes(AppPaths.TOKEN_ENDPOINT)) {
        this.lastTokenError = error instanceof HttpErrorResponse ? error : null;
      }
      throw error;
    }
  }

  resetLastTokenError(): void {
    this.lastTokenError = null;
  }

  getLastTokenError(): HttpErrorResponse | null {
    return this.lastTokenError;
  }

  private performRequest<T>(settings: XhrSettings): Promise<T | undefined> {
    const headers = this.getHeaders(settings.headers);
    switch (settings.method) {
      case 'GET':
        return this.http.get<T>(settings.url, {headers}).toPromise();
      case 'POST':
        return this.http.post<T>(settings.url, settings.data, {headers}).toPromise();
      case 'PUT':
        return this.http.put<T>(settings.url, settings.data, {headers}).toPromise();
      case 'DELETE':
        return this.http.delete<T>(settings.url, {headers}).toPromise();
      default:
        return Promise.resolve(undefined);
    }
  }

  private getHeaders(headers: any): HttpHeaders {
    let httpHeaders: HttpHeaders = new HttpHeaders();

    if (headers !== undefined) {
      Object.keys(headers).forEach(key => {
        httpHeaders = httpHeaders.append(key, headers[key]);
      });
    }

    return httpHeaders;
  }
}
